import qs from 'qs';

function parse<T = any>(params: any): T {
  return qs.parse(params, { arrayLimit: Number.POSITIVE_INFINITY, ignoreQueryPrefix: true }) as T;
}

function stringify(params: any) {
  return qs.stringify(params, { arrayFormat: 'brackets' });
}

const normalizingQs = { parse, stringify };
export default normalizingQs;
